export default __webpack_public_path__ + "static/media/B-.70353aad.svg";